import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

const STORAGE_KEY = 'yandex_disk_cookies';

const YandexDiskCookiesModal = ({ show, onHide }) => {
  const [cookiesValue, setCookiesValue] = useState('');

  useEffect(() => {
    if (show) {
      setCookiesValue(localStorage.getItem(STORAGE_KEY) || '');
    }
  }, [show]);

  const handleSave = () => {
    localStorage.setItem(STORAGE_KEY, cookiesValue);
    onHide();
  };

  const handleReset = () => {
    localStorage.removeItem(STORAGE_KEY);
    setCookiesValue('');
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Настройка Cookies Яндекс Диска</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group>
          <Form.Control
            as="textarea"
            rows={4}
            value={cookiesValue}
            onChange={(e) => setCookiesValue(e.target.value)}
            placeholder="Вставьте cookies сюда"
          />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleReset}>
          Сбросить
        </Button>
        <Button variant="secondary" onClick={onHide}>
          Отмена
        </Button>
        <Button variant="primary" onClick={handleSave}>
          Сохранить
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default YandexDiskCookiesModal;